import { call, put, retry } from 'redux-saga/effects';
import { publishAuthUserAccountsChanged } from '@nbx/frontend-helpers/publish';
import { ApplePayWalletExtension } from '@nbx/capacitor-apple-pay';
import { NBXStorage } from '@nbx/frontend-helpers/storage';
import { NBXAuth, NBXUsers } from 'services';

import ERRORS from 'constants/errors';
import STEPS from 'constants/steps';
import { createLogger } from 'helpers/logger';
import { setClaims, setError, stopLoading, setStep, setUser } from 'reduxConfig/auth.creators';

const log = createLogger('[auth-saga]');

export function* authGetUser({ userId = '', claims = {}, email }) {
  let user;
  try {
    const SECONDS = 1000;
    user = yield retry(3, SECONDS, NBXUsers.getProfile);
    [user.declarations] = yield call(NBXUsers.getDeclarations);
    window.DD_RUM?.setUser({
      id: userId
    });
    if (window.PLATFORM === 'ios') {
      yield call(ApplePayWalletExtension.writeData, user);
    }
  } catch (error) {
    user = { email, error: true };
  }
  try {
    const userAccounts = yield call(NBXAuth.getAccounts);
    yield call(publishAuthUserAccountsChanged, userAccounts);
  } catch (caughtError) {
    // TODO: Do we want to do something else with this?
    // An error in the dropdown menu or something?
    // or just abort login?
    console.error('Failed to fetch user accounts', caughtError); // eslint-disable-line
  }
  try {
    if (claims.roles.includes('KYC')) {
      NBXStorage.removeItem(`KYC-ACCEPTED-${userId}`, { useLocalStorage: true });
    }
    const kycAccepted = yield call(NBXStorage.getItem, `KYC-ACCEPTED-${userId}`, { useLocalStorage: true });
    if (kycAccepted) {
      claims.roles.push('KYC-ACCEPTED');
    }
    yield put(setClaims(claims));
    // Don't want to set user until everything else in place
    // The page redirects to dashboards as soon as user is set
    yield put(setUser(user));
    yield put(setStep(STEPS.RESET));
  } catch (e) {
    log.info('NBX get profile error: ', e); // eslint-disable-line
    // Dispatch a failure action to the store with the error
    yield put(setError(ERRORS.login));
  } finally {
    yield put(stopLoading());
  }
}
